import React, { useContext, useState } from 'react'
import { Popover } from 'antd'
import { icons } from '@/shahrzad-assets/shared-asstes/icons'
import styled from 'styled-components'
import { dimens } from '@/shahrzad-assets/shared-constants/dimens'
import { fontSize } from '@/shahrzad-assets/shared-constants/fonts'
import { Link } from 'react-router-dom'
import { sharedPathes } from '@/shahrzad-assets/shared-routing/pathe'
import useExit from '@/shahrzad-assets/shared-hooks/useExit'
import { colors } from '@/shahrzad-assets/shared-constants/colors'
import { FlexAC } from '../style-components/Flex'
import { UserInfoContext } from '@/shahrzad-assets/shared-contexts/UserInfoContext'

const ProfileSmallUp = () => {
  const [open, setOpen] = useState(false)
  const { userInfo } = useContext(UserInfoContext)
  const { exit } = useExit()

  const content = (
    <>
      <Link to={import.meta.env.VITE_MAIN_WEB_URL + sharedPathes.PROFILE}>
        <UserInfo>
          <FlexAC>
            <FlexAC>
              <IconContainar>
                <img src={icons.PROFILE_FILLED_BLACK} />
              </IconContainar>
              <div>
                <h5>{userInfo?.DisplayName}</h5>
                <span>{userInfo?.Mobile}</span>
              </div>
            </FlexAC>
            <div>
              <img src={icons.ARROW_LEFT_BLACK} />
            </div>
          </FlexAC>
        </UserInfo>
      </Link>
      <hr />
      {/* <Link to={import.meta.env.VITE_MAIN_WEB_URL + sharedPathes.SETTING}>
        <ListRight>
          <img src={icons.SETTING} />
          <span>تنظیمات</span>
        </ListRight>
      </Link>
      <hr /> */}
      <ListRight onClick={exit}>
        <img src={icons.EXIT_RED} />
        <span className='exitColor'>خروج از حساب کاربری</span>
      </ListRight>
    </>
  )

  const hide = () => {
    setOpen(false)
  }

  const handleOpenChange = (newOpen: boolean) => {
    setOpen(newOpen)
  }

  return (
    <>
      <CustomPopover
        placement='bottom'
        content={content}
        trigger='click'
        open={open}
        onOpenChange={handleOpenChange}
      >
        <img src={icons.PROFILE_FILLED_BLACK} />
      </CustomPopover>
    </>
  )
}

export default ProfileSmallUp

const CustomPopover = styled(Popover)`
  border-radius: ${dimens.BORDER_RADIUS_4};
`
const UserInfo = styled.div`
  display: flex;
  align-items: center;
  padding: ${dimens.SPACING_S};
  img {
    margin-left: ${dimens.SPACING_XS};
  }
  h5 {
    font-size: ${fontSize.MEDIUM};
  }
  span {
    font-size: ${fontSize.SMALL};
  }
`

const ListRight = styled.div`
  padding: ${dimens.SPACING_S};
  img {
    margin-left: ${dimens.SPACING_XS};
  }
  display: flex;
  align-items: center;
  cursor: pointer !important;
  .exitColor {
    color: ${colors.RED};
  }
`

const IconContainar = styled.div`
  img {
    cursor: pointer;
  }
`
